import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import ErrorTooltip from 'components/lib/error_tooltip';
import Input from 'components/common/input';

export default class InputWithResettableErrors extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      suppressErrors: false,
    };

    _.bindAll(this, ['handleKeyDown']);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (_.isEmpty(nextProps.errors)) {
      this.setState({ suppressErrors: false });
    }
  }

  render() {
    var errorsToDisplay = [];
    if (!_.isEmpty(this.props.errors)) {
      errorsToDisplay = this.props.errors.slice(0, 1);
    }

    return (
      <ErrorTooltip errors={this.state.suppressErrors ? [] : errorsToDisplay}>
        <div className="inputErrorWrapper">
          <Input
            onChange={this.props.onChange}
            value={this.props.value}
            placeholder={this.props.placeholder}
            onKeyDown={this.handleKeyDown}
            wrapperClassName={this.getInputWrapperClassName()}
            className={this.getInputClassName()}
            type={this.props.type}
          />
        </div>
      </ErrorTooltip>
    );
  }

  handleKeyDown() {
    this.setState({ suppressErrors: true });
  }

  getInputWrapperClassName() {
    return `${this.props.className}-wrapper`;
  }

  getInputClassName() {
    return `${this.props.className}-input editableField`;
  }
}

InputWithResettableErrors.propTypes = {
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.arrayOf(PropTypes.string),
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/integrations/lookup_api_config/input_with_resettable_errors.jsx